import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, FreeMode } from "swiper/modules";

function swiperFn() {
  const productSliders = document.querySelectorAll(".js-post-slider-row");

  if (productSliders.length) {
    productSliders.forEach((slider) => {
      let swiperInstance;
      let isMobileSlider = slider.classList.contains("is-mobile");

      const initSwiper = () => {
        let screenWidth = window.innerWidth;

        if (isMobileSlider) {
          if (
            screenWidth < 768 &&
            !slider.classList.contains("swiper-initialized")
          ) {
            // Initializing the slider for mobile devices
            initializeSwiper(slider);
          } else if (
            screenWidth >= 768 &&
            slider.classList.contains("swiper-initialized")
          ) {
            // Destroy slider when screen width >= 576px
            if (
              swiperInstance &&
              typeof swiperInstance.destroy === "function"
            ) {
              swiperInstance.destroy(true, true);
            }
          }
        } else {
          if (!slider.classList.contains("swiper-initialized")) {
            // Initialize the slider for other cases
            initializeSwiper(slider);
          }
        }
      };

      const initializeSwiper = (sliderElement) => {
        let sliderContainer = sliderElement.closest(".js-slider-container");
        let sliderArrows = sliderContainer.querySelector(".c-arrow");
        let navArrows = false;
        let countArrows = false;

        if (sliderArrows) {
          let next = sliderArrows.querySelector(".js-arrow-next");
          let prev = sliderArrows.querySelector(".js-arrow-prev");
          let countEl = sliderArrows.querySelector(".c-arrow__count");
          navArrows = {
            nextEl: next,
            prevEl: prev,
          };
          countArrows = {
            el: countEl,
            type: "fraction",
          };
        }

        swiperInstance = new Swiper(sliderElement, {
          modules: [Navigation, Pagination, Autoplay, FreeMode],
          slidesPerView: "auto",
          watchOverflow: true,
          spaceBetween: 15,
          freeMode: true,
          autoplay: {
            delay: 2500,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          navigation: navArrows,
          pagination: countArrows,
          breakpoints: {
            360: {
              slidesPerView: 1.1,
            },
            400: {
              slidesPerView: 1.2,
            },
            460: {
              slidesPerView: "auto",
            },
          },
        });
      };

      initSwiper();

      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          initSwiper();
        }, 200);
      });

      // let sliderContainer = slider.closest('.js-slider-container');
      // let sliderArrows = sliderContainer.querySelector('.c-arrow');
      // let navArrows = false;
      // let countArrows = false;

      // if (sliderArrows) {
      //   let next = sliderArrows.querySelector('.js-arrow-next');
      //   let prev = sliderArrows.querySelector('.js-arrow-prev');
      //   let countEl = sliderArrows.querySelector('.c-arrow__count');
      //   navArrows = {
      //     nextEl: next,
      //     prevEl: prev
      //   };
      //   countArrows = {
      //     el: countEl,
      //     type: "fraction",
      //   };
      // }

      // let swiperConfig = {
      //   modules: [Navigation, Pagination, Autoplay, FreeMode],
      //   slidesPerView: 'auto',
      //   watchOverflow: true,
      //   spaceBetween: 15,
      //   freeMode: true,
      //   autoplay: {
      //     delay: 2500,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: true,
      //   },
      //   navigation: navArrows,
      //   pagination: countArrows,
      // };

      // if (isMobileSlider && window.innerWidth <= 768) {
      //   new Swiper(slider, swiperConfig);
      // } else if (!isMobileSlider) {
      //   new Swiper(slider, swiperConfig);
      // }
      // else {
      //   new Swiper(slider, swiperConfig);
      // }
    });
  }
}

export default swiperFn;
